import React from 'react';
import PropTypes from 'prop-types';

/**
 * `.id-chip` from the detail-page spec — JetBrains Mono 11.5px on
 * `--surface-2`, 4px radius. Used in breadcrumbs and as a leading table cell.
 */
function IdChip({ children }) {
	return (
		<span className='tw:inline-flex tw:items-center tw:rounded-[4px] tw:bg-surface-2 tw:px-1.5 tw:py-0.5 tw:font-mono tw:text-[11.5px] tw:text-ink-2'>
			{children}
		</span>
	);
}

IdChip.propTypes = {
	children: PropTypes.node.isRequired,
};

export default IdChip;
